export const OFFICIAL_FULL_NAME_BLOCK_ID = 'officialFullName';
export const PM_SIGNER_POSITION_BLOCK_ID = 'pmSignerPosition';
export const PM_SIGNERS_BLOCK_ID = 'signers';
export const getPmSignersSignerFioBlockId = (id: string) => `signers[${id}].fioSigner`;
export const getPmSignersSignerPositionBlockId = (id: string) => `signers[${id}].titleSigner`;
export const MANUAL_ADDRESS_BLOCK_ID = 'manualAddress';
export const REGION_BLOCK_ID = 'region';
export const FEDERAL_LAW_BLOCK_ID = 'federalLawBlockId';
export const KNO_ORGANIZATION_BLOCK_ID = 'knoOrganizationBlock';
export const SUPERVISION_TYPE_BLOCK_ID = 'supervisionTypeBlock';
export const PM_TYPE_BLOCK_ID = 'pmTypeBlock';
export const START_DATE_BLOCK_ID = 'startDateBlock';
export const STOP_DATE_BLOCK_ID = 'stopDateBlock';
export const PM_FORM_BLOCK_ID = 'pmFormBlock';
export const LOCATION_BLOCK_ID = 'locationBlock';
export const EXTENSION_BLOCK_ID = 'extensionBlock';
export const NOTE_WARNING_BLOCK_ID = 'noteWarningBlock';
export const CONTENT_WARNING_BLOCK_ID = 'contentWarningBlock';
export const OBJECTION_WARNING_BLOCK_ID = 'objectionWarningBlock';
export const REASONS_BLOCK_ID = 'reasonsBlock';
export const EVENTS_BLOCK_ID = 'eventsBlock';
export const getEventBlockId = (id: string) => `eventsPm[${id}]`;
export const getReasonBlockId = (id: string) => `reasons[${id}]`;
export const getPeriodSuspensionEventBlockId = (id: string) => `suspensionEvents[${id}]`;
export const getPeriodSuspensionEventBlockAttachmentsId = (id: string) => `suspensionEvents[${id}].attachments`;
export const getPeriodSuspensionEventBlockEventId = (id: string) => `suspensionEvents[${id}].event`;
export const getPeriodSuspensionEventBlockDecisionDateTimeId = (id: string) =>
  `suspensionEvents[${id}].decisionDateTime`;
export const getPeriodSuspensionEventBlockDecisionNumberId = (id: string) => `suspensionEvents[${id}].decisionNumber`;
export const getPeriodSuspensionEventBlockStartDateId = (id: string) => `suspensionEvents[${id}].startDate`;
export const getPeriodSuspensionEventBlockStopDateId = (id: string) => `suspensionEvents[${id}].stopDate`;
export const INN_LABEL_BLOCK_ID = 'innLabelBlock';
export const OGRN_LABEL_BLOCK_ID = 'orgnLabelBlock';
export const ORGANIZATION_NAME_BLOCK_ID = 'organizationNameBlock';
export const OKVEDS_BLOCK_ID = 'okvedsBlock';
export const SNILS_BLOCK_ID = 'snilsBlockId';
export const DOCUMENT_BLOCK_ID = 'documentBlockId';
export const COUNTRY_BLOCK_ID = 'countryBlockId';
export const RAFP_NZA_BLOCK_ID = 'rafpNzaBlockId';
export const KPP_BLOCK_ID = 'kppBlockId';
export const OBJECTS_BLOCK_ID = 'objectsBlock';
export const INSPECTORS_BLOCK_ID = 'inspectorsBlock';
export const EXPERTS_BLOCK_ID = 'expertsBlock';
export const IS_UNABLE_TO_REFUSE_BLOCK_ID = 'isUnableToRefuseBlock';
export const getInspectorBlockId = (id: string) => `inspectors[${id}]`;
export const getExpertBlockId = (id: string) => `experts[${id}]`;
export const COLLABORATING_ORGANIZATIONS_BLOCK_ID = 'collaboratingOrganizationsBlock';
export const HAS_NOTIFICATIONS_BLOCK_ID = 'hasNotificationsBlock';
export const IS_REJECT_SUBJECT_BLOCK_ID = 'isRejectSubjectBlock';
export const REQUIREMENTS_NPA_BLOCK_ID = 'requirementsNpaBlock';
export const getRequirementsNpaBlockId = (id: string) => `requirementsNpa[${id}]`;
export const getCollaboratingOrganizationBlockId = (id: string) => `collaboratingOrganizations[${id}]`;
export const getOkvedBlockId = (id: string) => `okveds[${id}]`;

export const getPmResultDecisionsBlockId = (id: string) => `pmResultDecisions[${id}]`;
export const PM_RESULT_DECISIONS_BLOCK_ID = 'pmResultDecisionsBlock';

export const getPmResultDecisionsSignerBlockId = (id: string) => `pmResultDecisions[${id}].signer`;

export const ABROGATION_LINK_BLOCK_ID = 'abrogationLinkBlock';
export const ABROGATION_REASON_ID_BLOCK_ID = 'abrogationReasonIdBlock';
export const DOC_TARGET_BLOCK_ID = 'docTargetBlock';
export const getApproveDocBlockId = (id: string) => `approveDocs[${id}]`;
export const getReschedulingBlockId = (id: string) => `rescheduling[${id}]`;

export const getRiskIndicatorsBlockId = (id: string) => `reasonsPm[${id}].riskIndicators`;
export const getRiskIndicatorBlockId = (reasonId: string, indicatorRiskId: string) =>
  `reasonsPm[${reasonId}].riskIndicators[${indicatorRiskId}]`;

export const getComplexDataBlockId = (id: string) => `${id}`;

export const PM_ACT_BLOCK_ID = `act`;
export const PM_TAKEN_MEASURES_BLOCK_ID = `takenMeasures`;
export const getTakenMeasuresValueBlockId = (id: string) => `takenMeasures[${id}].value`;

export const VIDEO_CALL_INFO_WRAPPER_BLOCK_ID = `videoCallInfoWrapper`;
export const getVideoCallInfoBlockId = (id: string) => `videoCallInfo[${id}]`;
export const NOTE_WARNING_REACT_QUILL_EDITOR_BLOCK_ID = 'noteWarningReactQuillEditor';

export const AGREEMENTS_BLOCK_ID = 'agreementsBlock';
export const getAgreementsBlockId = (id: string) => `agreements[${id}]`;
export const SMEV_REQUEST_ID = `smevRequestId`;
export const SMEV_RESPONSE_ID = `smevResponseId`;
